export const CardReaderCommand = {
  CheckSerialNumber: 'checkSerialNumber',
  CardIssueRequest: 'cardIssueRequest',
  CardIssueWaiting: 'cardIssueWaiting',
  CardIssueWriting: 'cardIssueWriting',
  CardIssueRemoval: 'cardIssueRemoval',
  CardIssueComplete: 'cardIssueComplete',
  CardReadRequest: 'cardReadRequest',
  CardReadWaiting: 'cardReadWaiting',
  CardReadComplete: 'cardReadComplete',
} as const
export type CardReaderCommand = (typeof CardReaderCommand)[keyof typeof CardReaderCommand]

export type SelfCheckinCardReaderType = {
  serial_number: string
  command: CardReaderCommand
  message: string | undefined
  process_id: string
  is_success: boolean
  checkin?: {
    branch_number: number
    checkin_date: string
    checkout_date: string
    number_of_cards: number
    room_number: string | number
  }
}

export type RoomInfoType = {
  guestRoomAssignId: string
  roomNumber: string
  requiredCardCount: number
  assignCheckinDate: string
  assignCheckoutDate: string
  typeNameJa: string
  typeNameEn: string
  keyNumber: string | undefined
  qrCode: string | undefined
}
